import { LoadManager, PageHeader } from '@/components'
import { Container } from '@/components/styles'
import usePageTitle from '@/hooks/usePageTitle'
import React from 'react'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import clinicalCares from '@/services/api/clinicalCares'
import ClinicBox from './components/ClinicBox'

function Panel({ title }) {
  usePageTitle({ title })

  const { data, loading, error } = useAxiosRequest(clinicalCares.summaryDates)

  return (
    <Container className="grid-xl">
      <PageHeader
        title="Painel das clínicas"
        icon="fas fa-stream"
        subtitle="Visão geral dos atendimentos clínicos"
      />
      <LoadManager loading={loading} error={error}>
        {Boolean(data) && (
          Object.values(data).map(({ clinic, dates }) => (
            <ClinicBox clinic={clinic} dates={dates} data={data} key={clinic.id} />
          ))
        )}
      </LoadManager>
    </Container>
  )
}

export default Panel
